import React from "react";
import ProfileList from "../Profile/ProfileList";

const ProfileComponent = () => {
    return(
        <>
            <ProfileList/>
        </>
    );
}
export default ProfileComponent;
